import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { apiRequest } from "../services/api";
import { encryptData } from "./Common/encryptionUtils";
import { faL } from "@fortawesome/free-solid-svg-icons";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));
  const location = useLocation();
  
  // Payment Gateway Functionality Start
  
  // const [isAllowed, setIsAllowed] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   const verifyAccess = async () => {
  //     if (!token) {
  //       setIsAllowed(false);
  //       setIsLoading(false);
  //       return;
  //     }

  //     try {
  //       const authToken = localStorage.getItem("authToken");
  //       const headers = {
  //         Authorization: `Bearer ${authToken}`,
  //       };
  //       const res = await apiRequest(
  //         `web_api/admin/CheckSubscriptionStatus?customer_account_id=${encryptData(
  //           customerDetails?.customerAccountId.toString()
  //         )}`,
  //         "GET",
  //         null,
  //         headers
  //       );

  //       // You can customize the status condition here
  //       if (res.data.paymentStatus === "paid") {
  //         setIsAllowed(true);
  //       } else {
  //         setIsAllowed(true);
  //       }
  //     } catch (error) {
  //       console.error("Auth check failed", error);
  //       setIsAllowed(true);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   verifyAccess();
  // }, [location.pathname]);

  // const customerAccountId = customerDetails?.customerAccountId;

  // if (isLoading) return <div></div>;

  // Payment Gateway Functionality End

  if (!token) return <Navigate to="/signin" replace />;

  // Payment Gateway Functionality Start

  // if (!isAllowed)
  //   return (
  //     <Navigate
  //       to="/subscription/plan-details"
  //       replace
  //       state={{ customerAccountId }}
  //     />
  //   );

  // Payment Gateway Functionality End

  return children;
};

export default PrivateRoute;
